export default "__VITE_ASSET__MlGe_098__"